<template>
  <div class="flex items-center">
    <img
      v-if="socialIconSrcMap[props.socialType]"
      :src="socialIconSrcMap[props.socialType]"
      :style="{ width: props.size, height: props.size }"
      alt=""
      class="shrink-0"
    />
    <span class="ml-2 font-semibold">
      {{ ContentSocialTypeLabelMap[props.socialType] }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { ContentSocialType, ContentSocialTypeLabelMap } from '~/api/contents';
import FacebookContentSrc from '@/assets/images/social-media/facebook-content.svg?url';
import TwitterLogoSvg from '@/assets/images/social-media/twitter-logo.svg?component';
import LinkedinContentSrc from '@/assets/images/social-media/linkedin-content.svg?url';
import InstagramContentSrc from '@/assets/images/social-media/instagram-content.svg?url';
import { SocialIconSize } from '~/pages/_components/social-type-info/social-type-info.constants';

type Props = {
  socialType: ContentSocialType;
  size?: SocialIconSize;
};

const props = withDefaults(defineProps<Props>(), {
  size: SocialIconSize.MD,
});

const socialIconSrcMap: Record<ContentSocialType, string> = {
  // [ContentSocialType.TWITTER]: TwitterLogoSvg,
  [ContentSocialType.FACEBOOK]: FacebookContentSrc,
  [ContentSocialType.LINKEDIN]: LinkedinContentSrc,
  [ContentSocialType.INSTAGRAM]: InstagramContentSrc,
};
</script>
